//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import $ from 'jquery/dist/jquery.min.js'
import { validationMixin } from 'vuelidate'
import {
  required,
  minLength,
  maxLength,
  email,
  numeric,
  helpers
} from 'vuelidate/lib/validators'
import isURL from 'validator/lib/isURL'
import { v4 as uuidv4 } from 'uuid'
import { esaEncryptData } from '~/plugins/secret'
import useSupport from '@/components/useSupport'
const { companyCountryList } = useSupport()

const corporateEmail = (value) => {
  const match = /^\w+[-.\w]*@(\w+[-.\w]*?\.\w{2,4})$/.exec(value)
  const forbiddenDomains = [
    'hotmail.com',
    'outlook.com',
    'gmail.com',
    'yahoo.com'
  ]
  if (
    !match ||
    !match.length ||
    match.length < 2 ||
    forbiddenDomains.includes(match[1].toLowerCase())
  ) {
    return false
  }
  return true
}
const url = helpers.withParams(
  { type: 'url' },
  value => !helpers.req(value) || !!isURL(value)
)

export default {
  name: 'IGamingPaymentSolution',
  components: { },
  mixins: [validationMixin],
  // layout: 'single-default',
  // eslint-disable-next-line
  async asyncData ({ params, query }) {
    // const { source } = query
    // if (!source) {
    //   source = 'wix'
    // }
    // 服务端运行，线上获取不到
    const source = ''
    return { source }
  },
  data () {
    return {
      form: {
        name: '',
        areaCode: this.getAreaCode(),
        phone: '',
        email: '',
        company: '',
        companyWebsite: '',
        companySize: '',
        country: '',
        latamTransactions: '',
        knowUs: '',
        usageCountries: [],
        message: ''
      },
      sendingData: false,
      errorMessage: '',
      knowUsOption: this.getKnowUs(),
      industryOptions: this.getIndustryOpt(),
      countries: [],
      countriesList: require('@/components/contactus/countries.json'),
      employees: this.getEmployeesNumber(),
      transaction: this.getTransactions(),
      timer: null
    }
  },
  head () {
    this.source = this.source || 'default'
    // Pagsmile | Wix Integration for Merchants || Pagsmile | Shopify Integration for Merchants
    const titles = {
      wix: 'Pagsmile | Wix Integration for Merchants',
      shopify: 'Pagsmile | Shopify Integration for Merchants',
      default: 'Pagsmile'
    }
    return {
      title: titles[this.source],
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.$t('seo.description')
        }
      ]
    }
  },
  validations: {
    form: {
      name: {
        required,
        maxLength: maxLength(50)
      },
      phone: {
        required,
        numeric,
        minLength: minLength(7),
        maxLength: maxLength(11)
      },
      email: {
        required,
        email,
        corporateEmail,
        maxLength: maxLength(255)
      },
      company: {
        required,
        maxLength: maxLength(100)
      },
      companyWebsite: {
        required,
        url,
        maxLength: maxLength(300)
      },
      companySize: {
        required
      },
      country: {
        required
      },
      latamTransactions: {
        required
      },
      knowUs: {
        required
      },
      usageCountries: {
        required,
        minLength: minLength(1)
      },
      message: {
        required,
        minLength: minLength(10),
        maxLength: maxLength(1500)
      }
    }
  },
  computed: {
    serviceCountriesOpt () {
      if (this.source === 'wix') {
        return [
          {
            text:
              this.$i18n.locale === 'en'
                ? 'Brazil'
                : this.$i18n.t('br') || 'Brazil',
            value: 'BRA'
          },
          // {
          //   text:
          //     this.$i18n.locale === 'en'
          //       ? 'Colombia'
          //       : this.$i18n.t('co') || 'Colombia',
          //   value: 'COL'
          // },
          // {
          //   text:
          //     this.$i18n.locale === 'en' ? 'Peru' : this.$i18n.t('pe') || 'Peru',
          //   value: 'PER'
          // },
          {
            text:
              this.$i18n.locale === 'en'
                ? 'Chile'
                : this.$i18n.t('cl') || 'Chile',
            value: 'CHL'
          },
          {
            text:
              this.$i18n.locale === 'en'
                ? 'Mexico'
                : this.$i18n.t('mx') || 'Mexico',
            value: 'MEX'
          }
          // {
          //   text:
          //     this.$i18n.locale === 'en'
          //       ? 'Ecuador'
          //       : this.$i18n.t('ec') || 'Ecuador',
          //   value: 'ECU'
          // },
          // {
          //   text:
          //     this.$i18n.locale === 'en'
          //       ? 'El Salvador'
          //       : this.$i18n.t('sv') || 'El Salvador',
          //   value: 'SLV'
          // },
          // {
          //   text:
          //     this.$i18n.locale === 'en'
          //       ? 'Guatemala'
          //       : this.$i18n.t('gt') || 'Guatemala',
          //   value: 'GTM'
          // },
          // {
          //   text:
          //     this.$i18n.locale === 'en'
          //       ? 'Panama'
          //       : this.$i18n.t('pa') || 'Panama',
          //   value: 'PAN'
          // },
          // {
          //   text:
          //     this.$i18n.locale === 'en'
          //       ? 'Uruguay'
          //       : this.$i18n.t('uy') || 'Uruguay',
          //   value: 'URY'
          // },
          // {
          //   text:
          //     this.$i18n.locale === 'en'
          //       ? 'Paraguay'
          //       : this.$i18n.t('py') || 'Paraguay',
          //   value: 'PRY'
          // },
          // {
          //   text:
          //     this.$i18n.locale === 'en'
          //       ? 'Dominican Republic'
          //       : this.$i18n.t('do') || 'Dominican Republic',
          //   value: 'DOM'
          // },
          // {
          //   text:
          //     this.$i18n.locale === 'en'
          //       ? 'Argentina'
          //       : this.$i18n.t('ar') || 'Argentina',
          //   value: 'ARG'
          // },
          // {
          //   text:
          //     this.$i18n.locale === 'en'
          //       ? 'Japan'
          //       : this.$i18n.t('jp') || 'Japan',
          //   value: 'JPN'
          // },
          // {
          //   text:
          //     this.$i18n.locale === 'en'
          //       ? 'China'
          //       : this.$i18n.t('cn') || 'China',
          //   value: 'CHN'
          // },
          // {
          //   text:
          //     this.$i18n.locale === 'en'
          //       ? 'Indonesia'
          //       : this.$i18n.t('id') || 'Indonesia',
          //   value: 'IDN'
          // },
          // {
          //   text:
          //     this.$i18n.locale === 'en'
          //       ? 'Malaysia'
          //       : this.$i18n.t('my') || 'Malaysia',
          //   value: 'MYS'
          // },
          // {
          //   text:
          //     this.$i18n.locale === 'en'
          //       ? 'The Philippines'
          //       : this.$i18n.t('ph') || 'The Philippines',
          //   value: 'PHL'
          // },
          // {
          //   text:
          //     this.$i18n.locale === 'en'
          //       ? 'Thailand'
          //       : this.$i18n.t('th') || 'Thailand',
          //   value: 'THA'
          // },
          // {
          //   text:
          //     this.$i18n.locale === 'en'
          //       ? 'Korea'
          //       : this.$i18n.t('kr') || 'Korea',
          //   value: 'KOR'
          // },
          // {
          //   text:
          //     this.$i18n.locale === 'en'
          //       ? 'Cambodia'
          //       : this.$i18n.t('kh') || 'Cambodia',
          //   value: 'KHM'
          // }
        ]
      } else if (this.source === 'shopify') {
        return [
          { text: 'Latin America', value: 'Latin America' },
          { text: 'North America', value: 'North America' },
          { text: 'Europe', value: 'Europe' },
          { text: 'Asia', value: 'Asia' },
          { text: 'Africa & Middle East', value: 'Africa & Middle East' }
        ]
      }
      return []
    },
    isAllSelected () {
      if (
        this.serviceCountriesOpt &&
        this.serviceCountriesOpt.length &&
        this.form.usageCountries &&
        this.form.usageCountries.length
      ) {
        return (
          this.serviceCountriesOpt.length === this.form.usageCountries.length
        )
      }
      return false
    }
  },
  beforeUpdate () {
    /* fix the solutions not updating on language change */
    if (this.current_language !== this.$i18n.locale) {
      this.industryOptions = this.getIndustryOpt()
      this.knowUsOption = this.getKnowUs()
    }
  },
  created () {
    this.sendingData = true
  },
  mounted () {
    if (this.$route.query.source) {
      this.source = this.$route.query.source
    } else {
      this.source = 'wix'
    }
    this.showForm()
    this.resetForm()
    this.form.areaCode = this.getAreaCode()
    this.countries = this.getCountries()
    this.employees = this.getEmployeesNumber()
    this.transaction = this.getTransactions()
  },
  methods: {
    getFormId () {
      const { locale = 'en' } = this.$i18n
      const wixFormIds = {
        en: '1fb07b87-cc08-4c2a-a14a-a18a2f106f60',
        zh: '0b5dfd78-85b0-4ddd-82b0-0edd69c2a8c3',
        pt: '76853f33-11a5-49cc-b4f5-aa90cf184985',
        es: '079bba92-0b49-464a-ba2b-54ef9bee07c4'
      }
      const shopifyFormIds = {
        en: 'f9bbeb1e-bc19-4aee-8854-0d7fffaf45dc',
        zh: '72126670-ee94-4a74-bcd4-30bdb1b2f72e',
        pt: 'a94a52e6-7ac8-41e7-b1bc-ae97c177295b',
        es: '6a57892a-9795-4ddd-af9b-f396850f9d3e'
      }
      if (this.source === 'shopify') {
        return shopifyFormIds[locale]
      }
      return wixFormIds[locale]
    },
    showForm () {
      const that = this
      clearInterval(that.timer)
      if (!(window && window.hbspt && window.hbspt.forms && window.hbspt.forms.create)) {
        that.timer = setTimeout(() => {
          that.showForm()
        }, 10)
        return false
      }
      const formId = this.getFormId()
      const { locale = 'en' } = that.$i18n
      // console.log('locale ------>', locale)
      window.hbspt.forms.create({
        region: 'na1',
        portalId: '47030039',
        formId,
        target: '#hs-support',
        locale,
        onBeforeFormInit: () => {},
        onFormReady: () => {
          that.$nextTick(() => {
            setTimeout(() => {
              window.scrollTo({
                top: document.querySelector('#scrollPoint').offsetTop + 320,
                behavior: 'smooth'
              })
              // locale === 'zh' 中文隐藏错误提示
              if (locale === 'zh') {
                const hsSupport = document.getElementById('hs-support')
                // hsSupport.classList.add('hs-support-errors')
                const config = { attributes: true, childList: true, subtree: true }
                const callback = function (mutationsList, observer) {
                  for (const mutation of mutationsList) {
                    if (mutation.type === 'childList') {
                      mutation.addedNodes.forEach(node => {
                        if (node.nodeType === Node.ELEMENT_NODE) {
                          if (node.matches('ul')) {
                            // 找到了动态渲染的元素
                            node.firstChild.firstChild.innerText = '此字段是必填项'
                          } else if (node.classList.contains('hs_error_rollup')) {
                            node.firstChild.firstChild.firstChild.innerText = '请填写所有必填字段。'
                          }
                        }
                      })
                    }
                  }
                }
                const observer = new MutationObserver(callback)
                observer.observe(hsSupport, config)
              }
            }, 500)

            // hs_company_country 清空select 赋值
            const hsCompanyCountry = document.getElementsByClassName('hs_company_country')[0]
            const selectNode = hsCompanyCountry.querySelector('select')
            // console.log('selectNode', selectNode)
            let countries = []
            if (companyCountryList && companyCountryList[locale]) {
              countries = companyCountryList[locale]
            }
            const selectNodeHtmlBean = {
              en: '<option disabled="" value="">Select</option>',
              zh: '<option disabled="" value="">请选择</option>',
              pt: '<option disabled="" value="">Escolher</option>',
              es: '<option disabled="" value="">Seleccione</option>'
            }
            let selectNodeHtml = selectNodeHtmlBean[locale]
            countries.forEach(country => {
              selectNodeHtml = `${selectNodeHtml}<option value="${country}">${country}</option>`
            })
            selectNode.innerHTML = selectNodeHtml
          })
          that.sendingData = false
        },
        onBeforeFormSubmit: ($form) => {
          that.sendingData = true
        },
        onFormSubmitted: ($form) => {
          that.sendingData = false
          /* baidu analytics submit start */
          window._agl && window._agl.push(['track', ['success', { t: 3 }]])
          /* baidu analytics submit end */
        }
      })
    },
    getQueryString (name) {
      const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
      const r = window.location.search.substring(1).match(reg)
      if (r != null) {
        return unescape(r[2])
      }
      return null
    },
    getIndustryOpt () {
      const industries = []
      for (let i = 1; i < 14; i++) {
        industries.push({
          value: `${i}`,
          displayName: this.$i18n.t(`sales-contact-form-industry-${i}`)
        })
      }
      return industries
    },
    getKnowUs () {
      return [
        {
          value: 'Referral',
          displayName: this.$i18n.t('contact-us.know-us-referral')
        },
        {
          value: 'Linkedin',
          displayName: this.$i18n.t('contact-us.know-us-linkedin')
        },
        {
          value: 'Google',
          displayName: this.$i18n.t('contact-us.know-us-google')
        },
        {
          value: 'News / Blogs / Magazines',
          displayName: this.$i18n.t('contact-us.know-us-news')
        },
        {
          value: 'Other',
          displayName: this.$i18n.t('contact-us.know-us-other')
        }
      ]
    },
    validateState (name) {
      const { $dirty, $error } = this.$v.form[name]
      return $dirty ? !$error : null
    },
    onSubmit () {
      // console.log(this.form)
      const self = this
      this.$v.form.$touch()
      if (this.$v.form.$anyError) {
        this.errorMessage = this.$i18n.t('contact-us.field-error')
        return
      }
      const uuid = uuidv4().replace(/-/g, '')
      const coopApplUrl = `${process.env.APIURL}/website/common/notification/support`
      const {
        name,
        areaCode,
        phone,
        email,
        company,
        companyWebsite,
        companySize,
        country,
        latamTransactions,
        knowUs,
        usageCountries,
        message
      } = this.form
      const source = this.getQueryString('source') || ''
      const data = {
        basic_info: {
          full_name: name,
          area_code: areaCode,
          phone_number: phone,
          business_email: email,
          company_name: company,
          company_website: companyWebsite,
          company_size: companySize,
          country,
          latam_transaction_volume: latamTransactions,
          info_sources: knowUs
        },
        region: usageCountries,
        demand: message,
        source
      }
      // console.log('data', JSON.stringify(data))
      const settings = {
        url: coopApplUrl,
        method: 'POST',
        timeout: 0,
        headers: {
          'Content-Type': 'application/json'
        },
        data: JSON.stringify({
          key: this.$encrypt(uuid),
          data: esaEncryptData(JSON.stringify(data), uuid)
        })
      }
      this.sendingData = true
      $.ajax(settings)
        .done(function (response) {
          self.sendingData = false
          if (response.code === '10000') {
            self.$toast.success(response.msg, { timeout: 2000 })
            self.errorMessage = ''
            self.resetForm()
            return true
          } else {
            console.log('Error: ', response.msg)
            self.$toast.error(response.msg)
          }
        })
        .catch((error) => {
          console.log('Error: ', error)
          self.sendingData = false
        })
    },
    resetForm () {
      this.errorMessage = ''
      this.sendingData = false
      this.form = {
        name: '',
        areaCode: this.getAreaCode(),
        phone: '',
        email: '',
        company: '',
        companyWebsite: '',
        companySize: '',
        country: '',
        latamTransactions: '',
        knowUs: '',
        usageCountries: [],
        message: ''
      }
      this.$nextTick(() => {
        this.$v.$reset()
      })
    },
    getCountries () {
      if (this.countriesList && this.countriesList.length) {
        const cntrs = [...this.countriesList]
        const uniqueIds = new Set()
        const uniqueCountries = cntrs.filter((country) => {
          const isDuplicate = uniqueIds.has(country.countryName)
          if (!isDuplicate) {
            uniqueIds.add(country.countryName)
            return true
          }
          return false
        })
        uniqueCountries.forEach((country) => {
          if (typeof country.code === 'string') {
            country.iso2 = country.code.substring(0, 2).toUpperCase()
            country.iso3 = country.code.substring(5).toUpperCase()
            if (this.$i18n.locale !== 'en') {
              country.displayName = this.$i18n.t(country.iso2.toLowerCase())
            } else {
              country.displayName = country.countryName
            }
          }
        })
        return uniqueCountries
      }
      return []
    },
    getAreaCode () {
      if (this.$i18n.locale === 'zh') {
        return '86'
      } else {
        return '55'
      }
    },
    getEmployeesNumber () {
      return [
        {
          value: 'none',
          displayName: this.$i18n.t('contact-us.company-size-opt1'),
          disabled: true
        },
        {
          value: '1-10',
          displayName: '1-10'
        },
        {
          value: '11-50',
          displayName: '11-50'
        },
        {
          value: '51-100',
          displayName: '51-100'
        },
        {
          value: '101-1000',
          displayName: '101-1000'
        },
        {
          value: '1000-More',
          displayName: '1000+'
        }
      ]
    },
    getTransactions () {
      return [
        {
          value: 'none',
          displayName: this.$i18n.t('contact-us.company-volume-opt1'),
          disabled: true
        },
        {
          value: '$0-$500k',
          displayName: '$0 - $500k USD'
        },
        {
          value: '$500k-$999k',
          displayName: '$500k - $999k USD'
        },
        {
          value: '$1M-$9M',
          displayName: '$1M - $9M USD'
        },
        {
          value: '$10M-$50M',
          displayName: '$10M - $50M USD'
        },
        {
          value: '$51M-$100M',
          displayName: '$51M - $100M USD'
        },
        {
          value: '$100M-More',
          displayName: '$100M+ USD'
        }
      ]
    },
    selectAllCountries () {
      const checkboxes = document.getElementsByName('usage-countries-field')
      const checkboxesArr = [...checkboxes]
      const checkedValue = !this.isAllSelected
      checkboxesArr.forEach((checkbox) => {
        if (checkbox.checked !== checkedValue) {
          checkbox.click()
        }
      })
    }
  }
}
